import styled from "styled-components";

import { TextField } from "components/Form";

export const InputChangePage = styled(TextField)`
  height: 32px !important;
  text-align: center !important;
`;

export const DivMaxW = styled.div`
  max-width: 60px;
`;

export const PaginationBtnDiv = styled.div`
  padding: 5px;
`;
